import { render, staticRenderFns } from "./SCardSaleDetailComp.vue?vue&type=template&id=d430f69e&"
import script from "./SCardSaleDetailComp.vue?vue&type=script&lang=js&"
export * from "./SCardSaleDetailComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports